const contact = {
    title: 'دریافت کمک',
    description: 'برای درخواست کمک یا بازخورد محصول، لطفاً از طریق روش‌های زیر با ما تماس بگیرید.',
    discord: {
        title: 'پیوستن به جامعه دیسکورد',
        description: 'با سایر توسعه‌دهندگان ارتباط برقرار کنید تا راه‌حل پیدا کنید',
        button: 'پیوستن',
    },
    github: {
        title: 'ارتباط در گیت‌هاب',
        description: 'یک مشکل ایجاد کنید و در گیت‌هاب ارسال کنید',
        button: 'باز کردن',
    },
    email: {
        title: 'تماس با پشتیبانی از طریق ایمیل',
        description: 'برای اطلاعات بیشتر و کمک، برای ما ایمیل بفرستید',
        button: 'ارسال',
    },
    reserve: {
        title: 'زمان خود را با تیم لاگتو رزرو کنید',
        description: 'به سرعت یک جلسه برای گفتگوی زنده رزرو کنید',
        button: 'رزرو',
    },
};
export default Object.freeze(contact);
